var m = require('mithril');
var heading = require('../../components/heading');
var d3 = require('d3');
var io = require('../../libs/socketio');
var directPointSubscription = require('../../components/directPointSubscription');
var edit = require('../../layout/components/edit');
var builderEditView = require('../../libs/builderEditView');
var helpModal = require('../../help/helpModal');

var oninit = function (vnode) {
  var ctrl = this;
  ctrl.element = vnode.attrs.element;
  ctrl.parentReinitialize = vnode.attrs.parentReinitialize;
  ctrl.dashboardCallback = vnode.attrs.dashboardCallback;
  ctrl.subscriptions = {};
  ctrl.firstUpdate = true;

  ctrl.handleUpdate = function (data) {
    if (!(ctrl.subscriptions[data.rid])) {
      return
    }
    ctrl.subscriptions[data.rid].value = Number(data.value);
    var sub = ctrl.subscriptions[data.rid];
    var obj1 = d3.select('#abcde');
    console.log(obj1) //Bug here!
    var ng = d3.select(obj1.node().contentDocument).select('#' + sub.name);
    console.log(ng)
    console.log(sub)
    var datatest=0
    if(typeof ng !== "undefined" && sub.graphicComponent==="text"){  
      datatest=(Math.abs(sub.value*20))
      ng.transition()
        .ease("linear")
        .duration(0) //Can change
        .tween("text", function(d) {
          var that = this;
          var i = d3.interpolate(0, sub.value);  // Number(d.percentage.slice(0, -1))
          //var i = d3.interpolate(0, datatest);  // Number(d.percentage.slice(0, -1))
          return function(t) {
              d3.select(that).text(i(t).toFixed(4));
          };
        })
      ng.attr("transform", "translate(-9,0)");

      //Line Rotation
      var line= d3.select(obj1.node().contentDocument).select('#Lines'); 
      line.transition()
          .duration(0)
          .attrTween("transform", moveLine);
    }
    function moveLine(d, i, a) {
      var x = 114.35
      var y = 89.83
      var angle = 110+(0.9*datatest)
      //console.log(datatest)
      if(a === null||typeof a =="undefined"){
        return d3.interpolateString("rotate(0, "+x+", "+y+")", "rotate(0, "+x+", "+y+")");
      }else{
        return d3.interpolateString("rotate(0, "+x+", "+y+")", "rotate("+ angle+", "+x+", "+y+")");
      }
    }
    //console.log(sub.graphicComponent)
    if(typeof ng !== "undefined" && sub.graphicComponent==="box"){
      if (sub.value) {
        ng.style('fill-opacity', 1)
      } else {
        console.log("E2")
        ng.style('fill-opacity', 0)
      }
    }
  }
  
  
  edit.vm.editing() ? '': io.on('update', ctrl.handleUpdate); //Think about edit mode
  if (ctrl.element.out_Contains[0].in.out_Column) {
    ctrl.element.out_Contains[0].in.out_Column.map(function (columnEdge, idx) {
      // Subscribe
      directPointSubscription.subscribe(ctrl, columnEdge.in['@rid']);
      // Renew every 20 seconds
      var intervalId = setInterval(
        directPointSubscription.renew.bind(directPointSubscription, ctrl, columnEdge.in['@rid']),
        20000
      );
      ctrl.subscriptions[columnEdge.in['@rid']] = {
        name: columnEdge.name,
        graphicComponent: columnEdge.graphicComponent,
        intervalId: intervalId
      };
    });
  }
    
  }

  var onremove = function () {
    var ctrl = this
    for (var key in ctrl.subscriptions) {
      if (ctrl.subscriptions[key] && ctrl.subscriptions[key].intervalId) {
        clearInterval(ctrl.subscriptions[key].intervalId);
      }
    }
    directPointSubscription.release(ctrl);
    io.off('update', ctrl.handleUpdate);
  }


var view = function view () {
  var ctrl = this
  return m('div.f3', [
    m(heading, {
      label: ctrl.element.name, 
      class: 'f1 mb2', 
      element: ctrl.element, 
      parentReinitialize: ctrl.parentReinitialize, 
      dashboardCallback: ctrl.dashboardCallback
    }, [
      ctrl.element.helpText ?
        m('i.ion-ios-information-outline.white.f1.ml2', {
          onclick: () => {
            helpModal.editDialogue(ctrl.element.name, undefined, ctrl.element.helpText);
          }
        })
      :
        ''
    ]),
    edit.vm.editing() ?
      m(builderEditView, {element: ctrl.element, parentReinitialize: ctrl.parentReinitialize, columnNameRequired: true})
    : 
      m('object', {data: ctrl.element.src, type: 'image/svg+xml', id: 'abcde'}), 
  ])
}

module.exports = {oninit: oninit, view: view, onremove:onremove};
